module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point2_5-dd30298ee75265611c5033556cc2bcb4.jpg";